<template>
    <article class="bg-white rounded shadow-md flex flex-col md:flex-row">
        <div
            class="px-8 py-5 border-b md:border-b-0 md:border-r border-grey-200 flex-grow flex flex-col md:flex-row gap-8"
        >
            <div class="flex flex-col flex-grow-0 gap-6">
                <div class="w-44 h-24 bg-grey-30 rounded-s flex items-center">
                    <img
                        v-if="additionalData?.productImage"
                        :src="additionalData?.productImage"
                        :alt="result.Artikelnr.raw"
                        class="w-full h-full object-contain"
                    />

                    <div
                        class=""
                        v-if="
                            !additionalData?.productImage &&
                            result.casnr &&
                            additionalData?.casData?.smiles
                        "
                    >
                        <canvas
                            class="w-44 h-24"
                            v-smiles="additionalData?.casData?.smiles"
                        ></canvas>
                    </div>

                    <img
                        v-if="
                            !additionalData?.productImage &&
                            (!result.casnr || !additionalData?.casData?.smiles)
                        "
                        alt="No Image Available"
                        :src="baseUrl + 'assets/icons/no-photo.svg'"
                        class="w-full h-1/3 object-contain"
                    />
                </div>
                <div class="">
                    <div class="text-f7">Art. Nr.</div>
                    <div class="text-f7 font-bold">
                        {{ result.Artikelnr.raw }}
                    </div>
                </div>
            </div>
            <div class="flex flex-col flex-grow gap-5 justify-between">
                <div class="">
                    <a
                        v-if="result.Name_des_Herstellers"
                        class="flex flex-row items-center gap-4 mb-2"
                        :href="
                            '/actions/sapShop/products/brand-redirect?brand=' +
                            result.Name_des_Herstellers.raw
                        "
                    >
                        <div class="shadow-md p-2" v-if="!hideBrandimage">
                            <img
                                :src="
                                    '/actions/sapShop/products/brand-image?brand=' +
                                    result.Name_des_Herstellers.raw
                                "
                                :alt="result.Name_des_Herstellers.raw"
                                @error="hideBrandimage = true"
                                class="h-6 object-contain"
                            />
                        </div>
                        by {{ result.Name_des_Herstellers.raw }}
                    </a>
                </div>

                <a
                    :href="'/product/' + itemCodeToUrlSlug(result.Artikelnr.raw)"
                    target="_blank"
                    clasS="text-f4 font-bold break-word hyphens-auto"
                    v-if="result.Artikelbeschreibung"
                >
                    {{ result.Artikelbeschreibung.raw }}
                </a>

                <div
                    class="flex flex-row gap-8 lg:gap-16 xl:gap-32 flex-wrap lg:flex-nowrap"
                >
                    <div v-if="result.VerkaufsME">
                        <div class="text-f7">packaging unit</div>
                        <div class="text-f7 font-bold">
                            {{ result.VerkaufsME.raw }}
                        </div>
                    </div>
                    <div v-if="additionalData">
                        <div class="text-f7">stock / lead time</div>
                        <div class="text-f7 font-bold">
                            {{ availOrLeadText() }}
                        </div>
                    </div>
                    <div v-if="result.casnr && result.casnr.raw">
                        <div class="text-f7">CAS: {{ result.casnr.raw }}</div>
                        <a
                            :href="
                                '/shop?q=' +
                                result.casnr.raw +
                                '&size=n_20_n&filters%5B0%5D%5Bfield%5D=ExactCas&filters%5B0%5D%5Bvalues%5D%5B0%5D=b_true_b&filters%5B0%5D%5Btype%5D=all'
                            "
                            target="_blank"
                            class="text-f7 underline"
                        >
                            products with same CAS-Nr.
                        </a>
                    </div>
                    <div v-if="additionalData?.msdsUrl">
                        <a
                            :href="additionalData?.msdsUrl"
                            target="_blank"
                            class="text-f7 cursor-pointer flex flex-row items-center gap-2"
                        >
                            msds
                            <i class="fas fa-download text-primary ml-2"></i>
                        </a>
                        <a
                            v-if="result.casnr && result.casnr.raw"
                            :href="'/product/' + itemCodeToUrlSlug(result.Artikelnr.raw) + '#properties'"
                            class="block text-f7 underline"
                        >
                            Properties
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-grow-0 flex flex-col">
            <div
                class="flex-grow-0 border-b border-grey-200 py-4 px-5 flex flex-row gap-6 justify-end"
            >
                <div
                    class="inline-block text-[12px] text-grey-400"
                    v-if="result && result._score && result._score.raw"
                >
                    Score: {{ result._score.raw.toFixed(2) }}
                </div>
                <button
                    class="btn-list-cb"
                    @click.stop="addToOfferlist()"
                    title="add to offer list"
                ></button>
                <button
                    class="btn-pin-cb"
                    @click.stop="addToWatchlist()"
                    title="add to watchlist"
                ></button>
                <button
                    class="btn-compare-cb"
                    @click.stop="addToCompare()"
                    title="add to comparison list"
                ></button>
            </div>
            <div
                class="flex-grow p-5 flex flex-col justify-between gap-6 items-end md:items-start"
            >
                <div>
                    <div class="text-f4 font-bold">
                        {{
                            formatAsCurrency(
                                additionalData?.Preis ?? result.Listenpreis.raw,
                            )
                        }}
                    </div>
                    <div
                        class="text-f7 line-through"
                        v-if="
                            isLoggedIn &&
                            additionalData?.Preis &&
                            additionalData?.Preis < result.Listenpreis.raw
                        "
                    >
                        {{ formatAsCurrency(result.Listenpreis.raw) }}
                    </div>
                </div>
                <div class="">
                    <div class="flex flex-row items-center gap-4">
                        <button
                            class="w-8 h-8 bg-grey-50 hover:bg-grey-10 rounded-s font-bold text-f6"
                            @click="quantity > 1 ? quantity-- : null"
                        >
                            -
                        </button>
                        <input
                            type="number"
                            v-model="quantity"
                            class="w-12 text-center border-none text-f6 font-bold quantity-input"
                            min="1"
                        />
                        <button
                            class="w-8 h-8 bg-grey-50 hover:bg-grey-100 rounded-s font-bold text-f6"
                            @click="quantity++"
                        >
                            +
                        </button>
                        <button
                            class="px-4 py-2 bg-primary hover:bg-primary-light text-white rounded-s"
                            @click.stop="
                                addToCart(result.Artikelnr.raw, quantity)
                            "
                        >
                            <i class="fas fa-shopping-cart"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import { BASEURL } from "@libTs/cms.globals";
import { vSmiles } from "../../directives/v-smiles";
import { itemCodeToUrlSlug } from "../../helpers/url.helper";

export default {
    inject: [
        "cartSvc",
        "productsSvc",
        "watchlistSvc",
        "overlaysSvc",
        "itemSvc",
        "compareSvc",
        "offerSvc",
    ],
    props: {
        result: {
            type: Object,
            required: true,
        },
        additionalData: {
            type: Object,
            required: false,
            default: null,
        },
    },
    directives: {
        smiles: vSmiles,
    },
    data() {
        return {
            quantity: 1,
            isLoggedIn: this.cartSvc.isUserLoggedIn(),
            hideBrandimage: false,
            baseUrl: BASEURL,
        };
    },
    watch: {
        result: {
            handler() {
                this.quantity = 1; // Reset quantity when result changes
            },
            deep: true,
        },
    },
    methods: {
        itemCodeToUrlSlug,
        addToCart(artnr, qty) {
            if (this.isLoggedIn) {
                this.cartSvc.addItemToCart(
                    {
                        ItemCode: this.result.Artikelnr.raw,
                        ItemName: this.result.Artikelbeschreibung.raw,
                        Preis:
                            this.additionalData?.Preis ??
                            this.result.Listenpreis.raw,
                        SpecialPrice: this.additionalData?.SpecialPrice ?? null,
                        ImageURL: this.additionalData?.productImage ?? "",
                    },
                    qty,
                );
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        addToWatchlist() {
            if (this.isLoggedIn) {
                this.watchlistSvc.add({
                    ItemCode: this.result.Artikelnr.raw,
                    ItemName: this.result.Artikelbeschreibung.raw,
                    ImageURL: this.additionalData?.productImage ?? "",
                });
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        addToOfferlist() {
            if (this.isLoggedIn) {
                this.offerSvc.add({
                    ItemCode: this.result.Artikelnr.raw,
                    ItemName: this.result.Artikelbeschreibung.raw,
                    ImageURL: this.additionalData?.productImage ?? "",
                    Quantity: 1,
                    Preis:
                        this.additionalData?.Preis ??
                        this.result.Listenpreis.raw,
                });
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        addToCompare() {
            if (this.isLoggedIn) {
                this.compareSvc.add({
                    ItemCode: this.result.Artikelnr.raw,
                    ItemName: this.result.Artikelbeschreibung.raw,
                    ImageURL: this.additionalData?.productImage ?? "",
                    Group: this.result.Gruppenname.raw ?? "",
                });
            } else {
                this.overlaysSvc.showOverlay("loginForm");
            }
        },
        formatAsCurrency(value) {
            return new Intl.NumberFormat("de-CH", {
                style: "currency",
                currency: "CHF",
            }).format(value);
        },
        availOrLeadText() {
            if (!this.additionalData) {
                return "";
            }
            return this.itemSvc.availOrLeadText(
                this.additionalData.availability,
                this.additionalData.leadtime,
            );
        },
    },
};
</script>

<style scoped>
.search-result {
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    align-items: center;
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.search-result__heading {
    text-align: center;
    margin: 0;
}

.search-result__body {
    display: flex;
    justify-content: flex-start;
    align-self: flex-start;
}

.search-result__data {
    padding-top: 50px;
}

.search-result__flavor {
    margin: 0;
}

.search-result__image {
    flex: none;
    width: 256px;
    height: 387px;
}
</style>
